import React from "react";

import withDefaults from "../../utils/default-options"; 

export const ThemeContext = React.createContext({});

export const ThemeProvider = ({ children, themeOptions }) => {
  return (
    <ThemeContext.Provider value={withDefaults(themeOptions)}>
      {children}
    </ThemeContext.Provider>
  );
};
